module.exports = __webpack_public_path__ + "img/jouez.d91e53aa.png";